import { render, staticRenderFns } from "./AddCert.vue?vue&type=template&id=0e5dc62b&"
import script from "./AddCert.vue?vue&type=script&lang=js&"
export * from "./AddCert.vue?vue&type=script&lang=js&"
import style0 from "./AddCert.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports